export default `/* Ids Fieldset CSS */
fieldset {
  border: var(--ids-space-none);
}

fieldset > ::slotted(legend),
fieldset > legend {
  padding-block-end: var(--ids-space-sm);
  padding-inline: 0;
}

::slotted(ids-button) {
  margin-left: -4px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtZmllbGRzZXQiLCJzb3VyY2VzIjpbImlkcy1maWVsZHNldC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0FBQ0E7RUFDRTs7O0FBR0Y7QUFBQTtFQUVFO0VBQ0E7OztBQUdGO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIvKiBJZHMgRmllbGRzZXQgQ1NTICovXG5maWVsZHNldCB7XG4gIGJvcmRlcjogdmFyKC0taWRzLXNwYWNlLW5vbmUpO1xufVxuXG5maWVsZHNldCA+IDo6c2xvdHRlZChsZWdlbmQpLFxuZmllbGRzZXQgPiBsZWdlbmQge1xuICBwYWRkaW5nLWJsb2NrLWVuZDogdmFyKC0taWRzLXNwYWNlLXNtKTtcbiAgcGFkZGluZy1pbmxpbmU6IDA7XG59XG5cbjo6c2xvdHRlZChpZHMtYnV0dG9uKSB7XG4gIG1hcmdpbi1sZWZ0OiAtNHB4O1xufVxuIl19 */`;
